import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const LinkBoxGridStyles = makeStyles((theme) => ({
  container: {
    padding: "0 1rem",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start"
  },
  linkBoxContainer: {
    flex: "0 1 calc(50% - 10px)",
    marginBottom: "15px",
    padding: "10px",
    boxSizing: "border-box"
  },
  linkBox: {
    borderBottom: `1px dotted ${COLORS.GRAY}`,
    width: "95%",
    paddingBottom: "1rem",
    marginBottom: "1rem"
  },
  groupdHeading: {
    fontWeight: 600,
    fontSize: "2.5rem",
    paddingBottom: ".5rem",
    marginBottom: "3rem",
    borderBottom: `2px solid ${COLORS.GRAY}`,
    fontFamily: "Inter, sans-serif",
    color: COLORS.DARK_GRAY_2
  },

  navGroupHeading: {
    fontWeight: 600,
    fontSize: "1.3rem",
    fontFamily: "Inter, sans-serif",
    color: COLORS.DARK_GRAY_2
  },

  navGroup: {
    lineHeight: "2rem",
    marginTop: ".5rem"
  },

  question: {
    fontWeight: 600,
    fontSize: "1.5rem",
    marginBottom: ".25rem",
    fontFamily: "Inter, sans-serif",
    color: COLORS.DARK_GRAY_2
  },
  answer: {
    paddingBottom: "2rem",
    lineHeight: "1.65rem",
    fontSize: "1.15rem",
    borderBottom: `1px dotted ${COLORS.GRAY}`,
    fontFamily: "Inter, sans-serif",
    color: COLORS.DARK_GRAY_2
  },

  linkHover: {
    color: COLORS.DARK_GRAY_2,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },

  link: {
    color: COLORS.DARK_GRAY_2,
    textDecoration: "none",
    fontSize: "1.15rem",
    "&:hover": {
      textDecoration: "underline"
    }
  }
}));

export default LinkBoxGridStyles;
